import { Card, Col, Divider, List, Row, Select, Space, Spin, Statistic, Tooltip } from 'antd';
import React, { useState } from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import UsageStatistic from './UsageStatistic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPoll } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@fortawesome/fontawesome-svg-core';

interface VotesUsageListProps {
  company: Company | undefined;
}

export default function VotesUsage({
  company,
}: VotesUsageListProps) {
    
  const [range, setRange] = useState(-30);
  const usage = CustomerServiceQueries.useCompanyUsageVotes(company!.id, range)

  const handleChange = (value: string) => {
    setRange(Number(value))
  };

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faPoll as Icon}/> Votes</Space>} extra={<Select
      defaultValue={range.toString()}
      style={{ width: 160 }}
      onChange={handleChange}
      loading={usage.isFetching}
      options={[
        {
            value: "0",
            label: 'All Time',
        },
        {
            value: "-365",
            label: 'Past 365 Days',
        },
        {
            value: "-120",
            label: 'Past 120 Days',
        },
        {
            value: "-90",
            label: 'Past 90 Days',
        },
        {
            value: "-60",
            label: 'Past 60 Days',
        },
        {
            value: "-30",
            label: 'Past 30 Days',
        }
      ]}
    />} >
        <Spin spinning={usage.isLoading}>
            
    <Row gutter={[16,16]}>
        {usage.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item} />
            </Col>
        ))}
    </Row>
        </Spin>
    </Card>
    </>
  );
}
